import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import './config/config';
import { SessionProvider } from './session/SessionProvider';
//import history from './utils/history';
import { globalConfig } from './config/config';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';


const onRedirectCallback = appState => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  )
}

//     redirectUri={window.location.origin}
//     onRedirectCallback={onRedirectCallback}
//     audience={`https://${globalConfig.auth0.domain}/api/v2/`}
//     scope={'read:current_user read:current_user_metadata'}
//   	<SessionProvider>
//   	</SessionProvider>

ReactDOM.render(
  <Auth0Provider
    domain={globalConfig.auth0.domain}
    clientId={globalConfig.auth0.clientId}
	authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
  	<BrowserRouter>
    <App />
    </BrowserRouter>
  </Auth0Provider>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
